import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';
import { DataViewResponseTypes } from '@mode/shared/contract-common';

@Injectable({
  providedIn: 'root',
})
export class ExplorationService {
  constructor(private http: HttpClient) {}

  public createExploration(org: string, exploration: DataViewResponseTypes.Exploration) {
    return this.http.post(`/api/${org}/explorations`, exploration).toPromise();
  }

  /**
   * Load all explorations.
   *
   * This is used for the exploration index page. Additionally, this still uses
   * the older hal embed pattern for which there aren't FE types.
   *
   * TODO: Migrate this over to the new endpoint pattern when we have time. Ultimately,
   * this will be using a different representer so title/description can be handled appropriately.
   */
  public loadExplorations(org: string, user: string) {
    return this.http
      .get<any>(`/api/${org}/explorations/user/${user}`)
      .toPromise()
      .then((response) => response);
  }

  public updateExploration(org: string, id: string, exploration: DataViewResponseTypes.Exploration) {
    return this.http
      .put<ChartTypes.ExplorationResource>(
        `/api/${org}/explorations/${id}?embed[chart]=1&embed[creator]=1`,
        exploration
      )
      .toPromise();
  }

  public deleteExploration(org: string, id: string) {
    return this.http.delete(`/api/${org}/explorations/${id}`).toPromise();
  }

  loadExploration(accountId: string, explorationId: string): Promise<DataViewResponseTypes.ExplorationResponse> {
    const request = `/api/${accountId}/explorations/${explorationId}`;

    const paramArray = [
      'embed[chart]',
      'embed[report_run]',
      'embed[space]',
      'embed[creator]',
      'embed[switch_view][switch_attrs]',
      'embed[switch_view][last_successful_data_run][result]',
      'embed[switch_view][last_successful_data_run][creator]',
    ].map((param) => `${param}=1`);

    const requestWithParams = `${request}?${paramArray.join('&')}`;

    return this.http
      .get<DataViewResponseTypes.ExplorationResponse>(requestWithParams)
      .toPromise() as Promise<DataViewResponseTypes.ExplorationResponse>;
  }
}
